import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-img',
    template: `<picture>
    <source srcset="{{ imagePathWebp }}" type="image/webp">
    <source srcset="{{ imagePath }}" type="{{ typeImage }}">
    <img src="{{ imagePath }}" alt="{{ imageName }}" style="{{ style }}">
</picture>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImgComponent implements OnInit, OnChanges {

    @Input()
    imagePath: String = "";

    @Input()
    style: String = "";

    imagePathWebp: String = "";
    typeImage: String = "";
    imageName: String = "";
    

    constructor() { }

    ngOnInit(): void {
        this.transform();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.imagePath = changes.imagePath.currentValue;
        this.transform();
    }

    private transform() {
        this.convertPathToWebp();
        this.extractTypeImage();
        this.extractName();
    }

    private convertPathToWebp() {
        this.imagePathWebp = this.imagePath.split('.')[0] + ".webp";
    }

    private extractTypeImage() {
        this.typeImage = "image/" + this.imagePath.split('.')[1].toLowerCase();
    }

    private extractName() {
        const path_split = this.imagePath.split('/');
        this.imageName = path_split[path_split.length - 1].toLowerCase()
    }

}
